import { useContext } from "react";
import { AuthContext } from "../contaxts/AuthProvider";


const useAuth = () => {
    const auth = useContext(AuthContext);
    return auth;

}
export default useAuth;